import React from 'react'
import { FilterIcon } from '../components/easinsure/contracts'
import TwoColumns from 'elements/ClientTwoColumns'
import Cell from 'elements/Cell'
import { dateFormatter } from 'lib/helpers'
import rt from 'components/reactable.scss'
import { Table, Thead, Th, Tr, Td } from 'components/reactable'
import moment from 'moment'
import styles from './client.scss'
import cs from 'classnames'
import i18n from 'lib/i18n'

const _ = i18n('contracts')

const iconMap = [
	{ name: "credit", icon: require('!!url?limit=1024!image!resources/images/icn-credit.svg'), color: "#7e53c5" },
	{ name: "life", icon: require('!!url?limit=1024!image!resources/images/icn-life.svg'), color: "#ffcb00" },
	{ name: "health", icon: require('!!url?limit=1024!image!resources/images/icn-health.svg'), color: "#ef3c79" },
	{ name: "building", icon: require('!!url?limit=1024!image!resources/images/icn-home.svg'), color: "#63bc66" },
	{ name: "family", icon: require('!!url?limit=1024!image!resources/images/icn-family.svg'), color: "#ffa800" },
	{ name: "vehicle", icon: require('!!url?limit=1024!image!resources/images/icn-automotive.svg'), color: "#5b69c3" },
	{ name: "work_accident", icon: require('!!url?limit=1024!image!resources/images/icn-workinjuries.svg'), color: "#8e6e62" },
	{ name: "high_risk", icon: require('!!url?limit=1024!image!resources/images/icn-fire.svg'), color: "#f1524b" },
	{ name: "transport", icon: require('!!url?limit=1024!image!resources/images/icn-transport.svg'), color: "#3ba3f8" },
	{ name: "several", icon: require('!!url?limit=1024!image!resources/images/icn-misc.svg'), color: "#979797" },
]

const ContractDetails = ({ contract, onBackClicked, className, isPhone }) => {
	const dueDate = contract.contractDetails.dueDate.split('-').reverse().join('-')

	let termination = contract.contractDetails.terminationType + (contract.contractDetails.terminationDate.length ? ' sinds ' : '') + contract.contractDetails.terminationDate

	if (contract.contractDetails.terminationReason) {
		termination = termination + ' (' + contract.contractDetails.terminationReason + ')'
	}

	const col1 = [
		{ label: _('company'), value: contract.insuranceCompany },
		{ label: _('status'), value: contract.contractState },
		{ label: _('creationDate'), value: new moment(contract.contractDetails.startDate).format('DD-MM-YYYY') },
		{ label: _('fractionation'), value: contract.contractDetails.frequency },
		{ label: _('bm'), value: contract.contractDetails.bonusMalus },
		{ label: _('termination'), value: termination },
	]

	const col2 = [
		{ label: _('brokerName'), value: contract.contractDetails.brokerName },
		{ label: _('payment'), value: dueDate },
		{ label: _('collection'), value: contract.contractDetails.collectType },
		{ label: _('taxation'), value: contract.contractDetails.fiscality },
	]

	const riskCol1 = [
		{ label: _('definition'), value: (contract.contractDetails.risks[0].riskDescription.length !== 0) ? contract.contractDetails.risks[0].riskDescription : "" },
	]
	return (
		<Cell className={cs(isPhone ? styles.contractPhoneContent : className, !isPhone ? styles.noBorder : '')} style={{flexGrow: 1}}>
			<div className={styles.contractHeader}>
				<FilterIcon iconValue={iconMap[contract.brancheCode]}/>
				<div className={styles.contractTitle}>
					{contract.mainBranche}
				</div>
				<div onClick={() => onBackClicked()} className={styles.backButton}>
					<button>← {_('back')}</button>
				</div>
			</div>
			<div className={styles.contractNumber}>
				{`${_('policy')} ${contract.contractNumber}`}
			</div>
			<TwoColumns col1={col1} col2={col2} isPhone={isPhone} />
			<div className={styles.sectionHeader}>
				{_('risk')}
			</div>
			<TwoColumns col1={riskCol1} col2={[]} isPhone={isPhone} />
			<div className={styles.sectionHeader}>
				{_('guarantee')}:
			</div>
			{/* here make table look bettere */}
			<Table
				className="table"
				topPagination={false}
				sortable={[
					'productName', 'productOption',
				]}
				defaultSort={{
					column: 'documentDateCol',
					direction: 'desc',
				}}
			>
				<Thead>
					<Th column="productName">
						<strong>{_('product')}</strong>
					</Th>
					<Th column="productOption">
						<strong>{_('option')}</strong>
					</Th>
				</Thead>
				{contract.contractDetails.risks[0].products.length > 0 &&
					contract.contractDetails.risks[0].products.map((item, i) => (
						<Tr key={i}>
							<Td column="productName" data={item.product} />
							<Td column="productOption" data={item.option} />
						</Tr>
					))}
			</Table>
			<div className={styles.sectionHeader}>
				{_('images')}:
			</div>
			<Table
				className="table"
				itemsPerPage={7}
				filterPlaceholder={_('placeholder')}
				filterable={['documentType', 'documentDate']}
				sortable={[
					{ column: 'documentDate', sortFunction: 'Date' },
					'documentType',
				]}
				defaultSort={{
					column: 'documentDate',
					direction: 'desc',
				}}
			>
				<Thead className={styles.tableRow}>
					<Th className={cs(rt.pdfIcon, styles.iconTd)} column="documentMetaCol" label="" />
					<Th column="documentType">
						<strong>{_('type')}</strong>
					</Th>
					<Th column="documentDate">
						<strong>{_('date')}</strong>
					</Th>
				</Thead>
				{contract.contractDocuments.length > 0 &&
					contract.contractDocuments.map((item, i) => (
						<Tr
							i={item.id}
							key={i}
							className={cs("clickable", styles.tableRow)}
							onClick={() => window.open(`/data/document?id=${item.contractDocumentId}`, '_blank', 'noopener,noreferrer')}
						>
							<Td column="documentMetaCol" data={item.id} className={cs(rt.pdfIcon, styles.iconTd)}>
								<img src={require('resources/images/pdf-icon_1x.png')} />
							</Td>
							<Td column="documentType" data={item.contractDocumentType} />
							<Td column="documentDate" className={cs(rt.date, styles.lastElem)} data={dateFormatter(item.contractDocumentDate)} />
						</Tr>
					))}
			</Table>
		</Cell>
	)
}

export default ContractDetails



// WEBPACK FOOTER //
// ./elements/ClientContractDetails.jsx